module.exports = __webpack_public_path__ + "static/media/red_circle.70ba0222.png";